import ProgressBar from './components/ProgressBar'

export default ProgressBar



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-progressbar-component/src/index.js
// module id = D2wB
// module chunks = 0